import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { getBetsTranslation } from 'src/domains/layouts/shared/translations/bets';
import { BetTypeWrapper } from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/Bet.style';
import { BetHistoryType } from 'src/domains/players/webview/components/Account/betHistoryTab/BetHistoryTab.state';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const BetType = observer<{ bet: BetHistoryType }>('BetType', ({ bet }) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const config = ConfigComponents.get(common).config;

    if (bet.type === 'RAB') {
        return <BetTypeWrapper>{config.rabHeaderTitle}</BetTypeWrapper>;
    }

    const betLabel = getBetsTranslation(languagesState, config, bet.type);
    if (betLabel !== undefined) {
        return <BetTypeWrapper>{betLabel}</BetTypeWrapper>;
    }

    return null;
});
